/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  JobCardDetailDto,
  JobCardEventsResponseDto,
  JobCardsListResponseDto,
  JobCardsPartnerControllerListJobCardEventsParams,
  JobCardsPartnerControllerListJobCardsParams,
  ManualCompleteJobCardResponseDto
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type jobCardsPartnerControllerListJobCardsResponse200 = {
  data: JobCardsListResponseDto
  status: 200
}

export type jobCardsPartnerControllerListJobCardsResponse401 = {
  data: void
  status: 401
}

export type jobCardsPartnerControllerListJobCardsResponse403 = {
  data: void
  status: 403
}

export type jobCardsPartnerControllerListJobCardsResponseSuccess = (jobCardsPartnerControllerListJobCardsResponse200) & {
  headers: Headers;
};
export type jobCardsPartnerControllerListJobCardsResponseError = (jobCardsPartnerControllerListJobCardsResponse401 | jobCardsPartnerControllerListJobCardsResponse403) & {
  headers: Headers;
};

export type jobCardsPartnerControllerListJobCardsResponse = (jobCardsPartnerControllerListJobCardsResponseSuccess | jobCardsPartnerControllerListJobCardsResponseError)

export const getJobCardsPartnerControllerListJobCardsUrl = (partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/job-cards?${stringifiedParams}` : `/partners/${partnerId}/job-cards`
}

/**
 * Server-paginated, filterable and sorted Job Cards index (ENG-775), replacing the Hub Legacy view that queried Supabase directly. A factory holds 5,000+ job cards, so this always paginates and returns a `total` for the pager. Two exclusions match the Legacy index: job cards whose work order has no pinned Run Sheet, and job cards on archived work orders (unconditional — the detail read does not apply it, so a deep link to a card on a since-archived work order still resolves).
 * @summary List job cards for a partner
 */
export const jobCardsPartnerControllerListJobCards = async (partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: Parameters<typeof customFetch>[1]): Promise<jobCardsPartnerControllerListJobCardsResponse> => {

  return customFetch<jobCardsPartnerControllerListJobCardsResponse>(getJobCardsPartnerControllerListJobCardsUrl(partnerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCardsPartnerControllerListJobCardsQueryKey = (partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams,) => {
    return [
    `/partners/${partnerId}/job-cards`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobCardsPartnerControllerListJobCardsQueryOptions = <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCardsPartnerControllerListJobCardsQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>> = ({ signal }) => jobCardsPartnerControllerListJobCards(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCardsPartnerControllerListJobCardsQueryResult = NonNullable<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>>
export type JobCardsPartnerControllerListJobCardsQueryError = void


export function useJobCardsPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params: undefined |  JobCardsPartnerControllerListJobCardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>,
          TError,
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>,
          TError,
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List job cards for a partner
 */

export function useJobCardsPartnerControllerListJobCards<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCardsPartnerControllerListJobCardsQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List job cards for a partner
 */
export const prefetchJobCardsPartnerControllerListJobCardsQuery = async <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getJobCardsPartnerControllerListJobCardsQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getJobCardsPartnerControllerListJobCardsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCardsPartnerControllerListJobCardsQueryKey(partnerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>> = ({ signal }) => jobCardsPartnerControllerListJobCards(partnerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCardsPartnerControllerListJobCardsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>>
export type JobCardsPartnerControllerListJobCardsSuspenseQueryError = void


export function useJobCardsPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params: undefined |  JobCardsPartnerControllerListJobCardsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List job cards for a partner
 */

export function useJobCardsPartnerControllerListJobCardsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError = void>(
 partnerId: string,
    params?: JobCardsPartnerControllerListJobCardsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCardsPartnerControllerListJobCardsSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type jobCardsPartnerControllerGetJobCardResponse200 = {
  data: JobCardDetailDto
  status: 200
}

export type jobCardsPartnerControllerGetJobCardResponse401 = {
  data: void
  status: 401
}

export type jobCardsPartnerControllerGetJobCardResponse403 = {
  data: void
  status: 403
}

export type jobCardsPartnerControllerGetJobCardResponse404 = {
  data: void
  status: 404
}

export type jobCardsPartnerControllerGetJobCardResponseSuccess = (jobCardsPartnerControllerGetJobCardResponse200) & {
  headers: Headers;
};
export type jobCardsPartnerControllerGetJobCardResponseError = (jobCardsPartnerControllerGetJobCardResponse401 | jobCardsPartnerControllerGetJobCardResponse403 | jobCardsPartnerControllerGetJobCardResponse404) & {
  headers: Headers;
};

export type jobCardsPartnerControllerGetJobCardResponse = (jobCardsPartnerControllerGetJobCardResponseSuccess | jobCardsPartnerControllerGetJobCardResponseError)

export const getJobCardsPartnerControllerGetJobCardUrl = (partnerId: string,
    jobCardId: string,) => {




  return `/partners/${partnerId}/job-cards/${jobCardId}`
}

/**
 * Job Card Detail (ENG-775): the index fields plus project, route, the Run Sheet's latest version for the Latest/Superseded badge, the workload category inherited from the parent work order, Total Planned Labour Minutes at the pinned revision, derived productive time, and the checked-in crew.
 * @summary Get one job card
 */
export const jobCardsPartnerControllerGetJobCard = async (partnerId: string,
    jobCardId: string, options?: Parameters<typeof customFetch>[1]): Promise<jobCardsPartnerControllerGetJobCardResponse> => {

  return customFetch<jobCardsPartnerControllerGetJobCardResponse>(getJobCardsPartnerControllerGetJobCardUrl(partnerId,jobCardId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCardsPartnerControllerGetJobCardQueryKey = (partnerId: string,
    jobCardId: string,) => {
    return [
    `/partners/${partnerId}/job-cards/${jobCardId}`
    ] as const;
    }


export const getJobCardsPartnerControllerGetJobCardQueryOptions = <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCardsPartnerControllerGetJobCardQueryKey(partnerId,jobCardId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>> = ({ signal }) => jobCardsPartnerControllerGetJobCard(partnerId,jobCardId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined && jobCardId !== null && jobCardId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCardsPartnerControllerGetJobCardQueryResult = NonNullable<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>>
export type JobCardsPartnerControllerGetJobCardQueryError = void


export function useJobCardsPartnerControllerGetJobCard<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>,
          TError,
          Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerGetJobCard<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>,
          TError,
          Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerGetJobCard<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one job card
 */

export function useJobCardsPartnerControllerGetJobCard<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCardsPartnerControllerGetJobCardQueryOptions(partnerId,jobCardId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get one job card
 */
export const prefetchJobCardsPartnerControllerGetJobCardQuery = async <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getJobCardsPartnerControllerGetJobCardQueryOptions(partnerId,jobCardId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getJobCardsPartnerControllerGetJobCardSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCardsPartnerControllerGetJobCardQueryKey(partnerId,jobCardId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>> = ({ signal }) => jobCardsPartnerControllerGetJobCard(partnerId,jobCardId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCardsPartnerControllerGetJobCardSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>>
export type JobCardsPartnerControllerGetJobCardSuspenseQueryError = void


export function useJobCardsPartnerControllerGetJobCardSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerGetJobCardSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerGetJobCardSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one job card
 */

export function useJobCardsPartnerControllerGetJobCardSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError = void>(
 partnerId: string,
    jobCardId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerGetJobCard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCardsPartnerControllerGetJobCardSuspenseQueryOptions(partnerId,jobCardId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type jobCardsPartnerControllerListJobCardEventsResponse200 = {
  data: JobCardEventsResponseDto
  status: 200
}

export type jobCardsPartnerControllerListJobCardEventsResponse401 = {
  data: void
  status: 401
}

export type jobCardsPartnerControllerListJobCardEventsResponse403 = {
  data: void
  status: 403
}

export type jobCardsPartnerControllerListJobCardEventsResponse404 = {
  data: void
  status: 404
}

export type jobCardsPartnerControllerListJobCardEventsResponseSuccess = (jobCardsPartnerControllerListJobCardEventsResponse200) & {
  headers: Headers;
};
export type jobCardsPartnerControllerListJobCardEventsResponseError = (jobCardsPartnerControllerListJobCardEventsResponse401 | jobCardsPartnerControllerListJobCardEventsResponse403 | jobCardsPartnerControllerListJobCardEventsResponse404) & {
  headers: Headers;
};

export type jobCardsPartnerControllerListJobCardEventsResponse = (jobCardsPartnerControllerListJobCardEventsResponseSuccess | jobCardsPartnerControllerListJobCardEventsResponseError)

export const getJobCardsPartnerControllerListJobCardEventsUrl = (partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/job-cards/${jobCardId}/events?${stringifiedParams}` : `/partners/${partnerId}/job-cards/${jobCardId}/events`
}

/**
 * Every job_events row for the card, newest first — the source for both the Timeline and Table tabs (they are two renderings of one list). `job_event_metadata` is passed through unchanged so Legacy's event formatting ports verbatim, with worker names resolved server-side in one batched query rather than Legacy's per-event N+1.
 * @summary List a job card's event history
 */
export const jobCardsPartnerControllerListJobCardEvents = async (partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: Parameters<typeof customFetch>[1]): Promise<jobCardsPartnerControllerListJobCardEventsResponse> => {

  return customFetch<jobCardsPartnerControllerListJobCardEventsResponse>(getJobCardsPartnerControllerListJobCardEventsUrl(partnerId,jobCardId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getJobCardsPartnerControllerListJobCardEventsQueryKey = (partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams,) => {
    return [
    `/partners/${partnerId}/job-cards/${jobCardId}/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getJobCardsPartnerControllerListJobCardEventsQueryOptions = <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCardsPartnerControllerListJobCardEventsQueryKey(partnerId,jobCardId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>> = ({ signal }) => jobCardsPartnerControllerListJobCardEvents(partnerId,jobCardId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerId !== null && partnerId !== undefined && jobCardId !== null && jobCardId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCardsPartnerControllerListJobCardEventsQueryResult = NonNullable<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>>
export type JobCardsPartnerControllerListJobCardEventsQueryError = void


export function useJobCardsPartnerControllerListJobCardEvents<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params: undefined |  JobCardsPartnerControllerListJobCardEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>,
          TError,
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCardEvents<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>,
          TError,
          Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCardEvents<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a job card's event history
 */

export function useJobCardsPartnerControllerListJobCardEvents<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCardsPartnerControllerListJobCardEventsQueryOptions(partnerId,jobCardId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List a job card's event history
 */
export const prefetchJobCardsPartnerControllerListJobCardEventsQuery = async <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getJobCardsPartnerControllerListJobCardEventsQueryOptions(partnerId,jobCardId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getJobCardsPartnerControllerListJobCardEventsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getJobCardsPartnerControllerListJobCardEventsQueryKey(partnerId,jobCardId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>> = ({ signal }) => jobCardsPartnerControllerListJobCardEvents(partnerId,jobCardId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type JobCardsPartnerControllerListJobCardEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>>
export type JobCardsPartnerControllerListJobCardEventsSuspenseQueryError = void


export function useJobCardsPartnerControllerListJobCardEventsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params: undefined |  JobCardsPartnerControllerListJobCardEventsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCardEventsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useJobCardsPartnerControllerListJobCardEventsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a job card's event history
 */

export function useJobCardsPartnerControllerListJobCardEventsSuspense<TData = Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError = void>(
 partnerId: string,
    jobCardId: string,
    params?: JobCardsPartnerControllerListJobCardEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerListJobCardEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getJobCardsPartnerControllerListJobCardEventsSuspenseQueryOptions(partnerId,jobCardId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type jobCardsPartnerControllerManualCompleteResponse201 = {
  data: ManualCompleteJobCardResponseDto
  status: 201
}

export type jobCardsPartnerControllerManualCompleteResponse401 = {
  data: void
  status: 401
}

export type jobCardsPartnerControllerManualCompleteResponse403 = {
  data: void
  status: 403
}

export type jobCardsPartnerControllerManualCompleteResponse404 = {
  data: void
  status: 404
}

export type jobCardsPartnerControllerManualCompleteResponse422 = {
  data: void
  status: 422
}

export type jobCardsPartnerControllerManualCompleteResponseSuccess = (jobCardsPartnerControllerManualCompleteResponse201) & {
  headers: Headers;
};
export type jobCardsPartnerControllerManualCompleteResponseError = (jobCardsPartnerControllerManualCompleteResponse401 | jobCardsPartnerControllerManualCompleteResponse403 | jobCardsPartnerControllerManualCompleteResponse404 | jobCardsPartnerControllerManualCompleteResponse422) & {
  headers: Headers;
};

export type jobCardsPartnerControllerManualCompleteResponse = (jobCardsPartnerControllerManualCompleteResponseSuccess | jobCardsPartnerControllerManualCompleteResponseError)

export const getJobCardsPartnerControllerManualCompleteUrl = (partnerId: string,
    jobCardId: string,) => {




  return `/partners/${partnerId}/job-cards/${jobCardId}/manual-complete`
}

/**
 * Allows Hub users to complete a job card that is currently in_progress — for cases where a worker forgot to sign off. Updates the job card to complete, inserts a job_events record with manual_sign_off metadata, and completes the parent work order if this is the final job.
 * @summary Manually complete an in-progress job card
 */
export const jobCardsPartnerControllerManualComplete = async (partnerId: string,
    jobCardId: string, options?: Parameters<typeof customFetch>[1]): Promise<jobCardsPartnerControllerManualCompleteResponse> => {

  return customFetch<jobCardsPartnerControllerManualCompleteResponse>(getJobCardsPartnerControllerManualCompleteUrl(partnerId,jobCardId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getJobCardsPartnerControllerManualCompleteMutationKey = () => ['jobCardsPartnerControllerManualComplete'] as const;

export const getJobCardsPartnerControllerManualCompleteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerManualComplete>>, TError,JobCardsPartnerControllerManualCompleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerManualComplete>>, TError,JobCardsPartnerControllerManualCompleteMutationVariables, TContext> => {

const mutationKey = getJobCardsPartnerControllerManualCompleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof jobCardsPartnerControllerManualComplete>>, JobCardsPartnerControllerManualCompleteMutationVariables> = (props) => {
          const {partnerId,jobCardId} = props ?? {};

          return  jobCardsPartnerControllerManualComplete(partnerId,jobCardId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JobCardsPartnerControllerManualCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof jobCardsPartnerControllerManualComplete>>>

    export type JobCardsPartnerControllerManualCompleteMutationError = void
    export type JobCardsPartnerControllerManualCompleteMutationVariables = {partnerId: string;jobCardId: string}

    /**
 * @summary Manually complete an in-progress job card
 */
export const useJobCardsPartnerControllerManualComplete = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof jobCardsPartnerControllerManualComplete>>, TError,JobCardsPartnerControllerManualCompleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof jobCardsPartnerControllerManualComplete>>,
        TError,
        JobCardsPartnerControllerManualCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getJobCardsPartnerControllerManualCompleteMutationOptions(options), queryClient);
    }
